export default {
  name: "DetailTop",
  props: {
    info: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,
      statusTags: {
        0: {
          label: "新咨询",
          color: "#2DB6B6"
        },
        1: {
          label: "待回复",
          color: "#F3B251"
        },
        2: {
          label: "已回复",
          color: "#111111"
        },
        3: {
          label: "已关闭",
          color: "#B7B7B7"
        }
      }
    };
  },
  methods: {
    back: function back() {
      this.$router.back();
    },
    goConsultationHistory: function goConsultationHistory() {
      localStorage.setItem("consult-phone", this.info.phone);
      window.open("#/consult/list");
    }
  }
};